/**
 * Drug Reference Firestore + card schema constants.
 * Canonical field shapes: see docs/sample-output.json and docs/card-preview.html
 */

export const PEDIATRIC_STATUS = Object.freeze({
  ESTABLISHED: 'established',
  LIMITED_DATA: 'limited-data',
  NOT_ESTABLISHED: 'not-established',
  NOT_AVAILABLE: 'not-available',
});

export const INTERCHANGEABILITY = Object.freeze({
  HIGH: 'high',
  PARTIAL: 'partial',
  CONTEXT_DEPENDENT: 'context-dependent',
});

export const OMC_DISPLAY_LABEL = 'Other Medications for Consideration';

export const MISSING_DATA_MESSAGE = 'Not available — consult primary reference';

export const PEDIATRIC_NOT_ESTABLISHED_MESSAGE =
  'Pediatric use not established / not available';
